/**
 * a function, that does nothing
 */
export const noOp = (): void => {
  // Do nothing, if not provided by caller
};

/**
 * a function to provide to `Array.prototype.sort()`,
 * to prevent any sorting
 */
export const noSort = (): number => 0;

/**
 * a function to provide to `Array.prototype.filter()`,
 * to prevent any filtering
 */
export const noFilter = (): boolean => true;

export const stripHTMLTags = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

export const capitalise = (
  word: string | undefined,
  breakCharacter?: string,
): string | undefined => {
  if (!word) return;
  let itemsToCapitalise: string[];
  if (breakCharacter) {
    itemsToCapitalise = word.split(breakCharacter);
  } else {
    itemsToCapitalise = [word];
  }
  return itemsToCapitalise
    .map((i) => `${i[0].toLocaleUpperCase()}${i.slice(1)}`)
    .join(' ');
};

export const getTodaysDateInFormat = (format: 'yyyy-mm-dd'): string => {
  const today = new Date();

  return formatDate(today, format);
};

export const formatDate = (date: Date, format: 'yyyy-mm-dd'): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  switch (format) {
    case 'yyyy-mm-dd':
      return `${year}-${month}-${day}`;
  }
};

export const findRouteByPath = (routes: any, path: string): any | undefined => {
  for (const route of routes) {
    if (route.basePath?.path === path) {
      return route;
    }

    if (route.children) {
      const result = findRouteByPath(route.children, path);

      if (result) {
        return result;
      }
    }
  }

  return undefined;
};

export const findRouteByPathName = (
  routes: any,
  name: string,
): any | undefined => {
  for (const route of routes) {
    if (route.basePath?.name === name) {
      return route;
    }

    if (route.children) {
      const result = findRouteByPathName(route.children, name);

      if (result) {
        return result;
      }
    }
  }

  return undefined;
};
